/**
 * Platform fee constants — single source of truth for the CLIENT.
 *
 * These values have a server-side twin in server/api-util/fee-constants.js
 * (the server can't import from src/). If you change one, change the other:
 * src/util/fees.parity.test.js asserts they stay identical, so a lone edit
 * fails CI.
 *
 * MARKETPLACE_COMMISSION_RATE mirrors the Sharetribe Console
 * `providerCommission` asset (transactions/commission.json), which is what
 * real transaction math uses (server/api-util/lineItems.js). This constant
 * exists for seller-facing previews (earnings notes, breakdowns) and must be
 * kept in sync with Console. Verified 5% in Console on Aug 12, 2026.
 *
 * INSURANCE_RATE is Trad Market's charge to the seller for shipment
 * protection, applied to the product value at label purchase. It is NOT what
 * EasyPost bills us (EasyPost applies its own rate to the declared value).
 */
export const MARKETPLACE_COMMISSION_RATE = 0.05;

export const INSURANCE_RATE = 0.015;

/** Multiply a gross amount by this to get the seller's net after commission. */
export const EARNINGS_MULTIPLIER = 1 - MARKETPLACE_COMMISSION_RATE;

/**
 * Stripe processing fees, passed through at cost. The server's line-item
 * math (server/api-util/lineItems.js) charges these for real; the client
 * uses them for the seller's earnings preview, which assumes a domestic
 * sale (buyer card origin is unknowable at listing time).
 */
export const PROCESSING_FEE_DOMESTIC_RATE = 0.029;
export const PROCESSING_FEE_INTERNATIONAL_RATE = 0.044;
export const PROCESSING_FEE_FIXED_CENTS = 30;

/**
 * Client-only UI thresholds (no server twin): the insurance tip under the
 * price field renders once the asking price reaches this amount.
 */
export const INSURANCE_TIP_MIN_PRICE_SUBUNITS = 25000;
